
import React from 'react';

interface ThemeToggleProps {
  theme: 'light' | 'dark';
  toggleTheme: () => void;
  className?: string;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ theme, toggleTheme, className = "" }) => {
  return (
    <button
      onClick={toggleTheme}
      className={`relative w-12 h-7 shrink-0 rounded-full transition-all duration-500 ease-in-out flex items-center px-1 shadow-inner outline-none ${
        theme === 'dark' ? 'bg-blue-600' : 'bg-slate-200 dark:bg-slate-800'
      } ${className} active:scale-90`}
      aria-label="Alternar tema"
    >
      <div
        className={`w-5 h-5 rounded-full bg-white shadow-lg transform transition-transform duration-500 flex items-center justify-center ${
          theme === 'dark' ? 'translate-x-5' : 'translate-x-0'
        }`}
      >
        <i className={`fa-solid ${theme === 'dark' ? 'fa-moon text-[10px] text-blue-600' : 'fa-sun text-[10px] text-amber-500'} transition-all duration-500`}></i>
      </div>
    </button>
  );
};

export default ThemeToggle;
